import React, { Suspense, lazy, useEffect, useRef, useState } from "react";
import { FaFileSignature } from "react-icons/fa";
import { useAuth } from "../../AuthContext";
import { hasPermission, isAdmin } from "../../utils/permissions";
import SignatureOverlay from "./SignatureOverlay";
import EnrollmentGate from "./EnrollmentGate";
import { messageOf } from "./SignatureApi";
import "./signatures.css";
const NewSignatureRequest = lazy(() => import("./NewSignatureRequest"));
const SigningPanel = lazy(() => import("./SigningPanel"));
function PreparedDocument({ prepareFile, onClose, onSaveSigned }) {
  const builder = useRef(prepareFile);
  const [file, setFile] = useState(null),
    [error, setError] = useState(""),
    [request, setRequest] = useState(null),
    [signNow, setSignNow] = useState(false);
  useEffect(() => {
    let active = true;
    Promise.resolve()
      .then(() => builder.current())
      .then((result) => {
        if (!(result instanceof File) || result.type !== "application/pdf")
          throw new Error("Não foi possível preparar o PDF.");
        if (active) setFile(result);
      })
      .catch((e) => {
        if (active) setError(messageOf(e));
      });
    return () => {
      active = false;
    };
  }, []);
  if (request && signNow)
    return (
      <SigningPanel
        id={request.id}
        onClose={onClose}
        onSaveSigned={onSaveSigned}
      />
    );
  if (request)
    return (
      <div className="signature-panel">
        <h2>Solicitação enviada</h2>
        <p>Acompanhe o documento no módulo Assinaturas.</p>
        <button onClick={onClose}>Concluir</button>
      </div>
    );
  if (error)
    return (
      <div className="signature-panel">
        <p role="alert" className="signature-error">
          {error}
        </p>
        <button onClick={onClose}>Fechar</button>
      </div>
    );
  if (!file)
    return (
      <p role="status" className="signature-panel">
        Preparando PDF para assinatura…
      </p>
    );
  return (
    <NewSignatureRequest
      initialFile={file}
      onClose={onClose}
      onCreated={(created, options) => {
        setRequest(created);
        setSignNow(options?.signNow === true);
      }}
    />
  );
}
export default function SignGeneratedDocument({
  prepareFile,
  onSaveSigned,
  disabled = false,
  className = "",
  label = "Assinar documento",
}) {
  const { user } = useAuth() || {};
  const [builder, setBuilder] = useState(null);
  if (
    !user ||
    !(
      user.isMaster ||
      isAdmin(user) ||
      hasPermission(user, "CRIAR_ASSINATURAS")
    )
  )
    return null;
  const close = () => setBuilder(null);
  return (
    <>
      <button
        type="button"
        className={className}
        disabled={disabled}
        onClick={() => setBuilder(() => prepareFile)}
      >
        <FaFileSignature /> {label}
      </button>
      {builder && (
        <SignatureOverlay onClose={close}>
          <section
            className="signature-modal"
            role="dialog"
            aria-modal="true"
            aria-label="Assinar documento gerado"
          >
            <EnrollmentGate strict onClose={close}>
              <Suspense fallback={<p role="status">Carregando assinaturas…</p>}>
                <PreparedDocument
                  prepareFile={builder}
                  onClose={close}
                  onSaveSigned={onSaveSigned}
                />
              </Suspense>
            </EnrollmentGate>
            <button className="signature-generated-close" onClick={close}>
              Fechar
            </button>
          </section>
        </SignatureOverlay>
      )}
    </>
  );
}
